<template>
  <div class="grid-container">
    <v-layout>
      <v-col align-self="auto" cols="3">
        <filter-comp
          :accounts="support_accounts"
          hide_date_filter
          view="monitor"
          @apply_filters="
            applyFilters(
              $event.active_only,
              $event.filters,
              $event.sort,
              $event.selected_account
            )
          "
        ></filter-comp>
      </v-col>
      <v-col cols="9">
        <v-responsive v-if="monitors.length > 0">
          <div id="top"></div>
          <v-layout justify-center row wrap>
            <div
              class="pa-4"
              v-for="monitor in monitors"
              v-bind:key="monitor.monitor_id"
            >
              <monitor-preview :monitor="monitor" />
            </div>
          </v-layout>
        </v-responsive>
        <div v-else>
          <v-layout justify-center> No monitors to display</v-layout>
        </div>

        <v-layout class="paging-container">
          <paging-comp
            :paging_id="this.paging_id"
            :has_more="has_more"
            @next_page="$emit('next_page', { last_id: $event.last_id })"
            @prev_page="$emit('prev_page', { first_id: $event.first_id })"
            ref="pagingComp"
          ></paging-comp>
        </v-layout>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
import FilterComp from "@/components/shared/Filter.vue";
import MonitorPreview from "@/components/monitor/MonitorPreview.vue";
import PagingComp from "@/components/shared/Paging.vue";
import adminApi from "@/api/admin";
import { mapGetters } from "vuex";

export default {
  components: { FilterComp, MonitorPreview, PagingComp },
  props: ["monitors", "has_more", "loading", "paging_id"],
  data() {
    return {
      selected_account: "",
      support_accounts: [],
    };
  },
  computed: {
    ...mapGetters(["user_details"]),
  },
  mounted() {
    this.waitThenGetSupportAccounts();
  },
  methods: {
    applyFilters(active_only, filters, sort, selected_account) {
      // reset paging and push query params to router
      this.$refs.pagingComp.refreshPaging();
      this.$router
        .push({
          query: {
            active_only: active_only,
            filters: filters,
            sort: sort,
            selected_account: selected_account,
          },
        })
        .catch(() => {
          // catch redundant path error
        });
    },
    waitThenGetSupportAccounts() {
      if (this.user_details.account_id) {
        if (
          ("support_accounts" in this.user_details &&
            this.user_details.support_accounts.length > 0) ||
          this.user_details.super_admin
        ) {
          adminApi
            .fetch_all_accounts()
            .then((response) => {
              this.support_accounts = response;
            })
            .catch((error) => {
              return error;
            });
        }
      } else {
        setTimeout(this.waitThenGetSupportAccounts, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  /* full page height - 64px for nav bar and - 62px for footer */
  height: calc(100vh - 64px - 62px);
  overflow-y: auto;
}
.paging-container {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
